/* eslint-disable import/no-anonymous-default-export */
import { useEffect, useState } from "react";

import { FaBookmark } from '@react-icons/all-files/fa/FaBookmark';
import "./index.scss";
import { postRequest } from "../../../../services/requestService";
import { refreshStats } from '../../../../store/reducers/Jobs/actions'
import { Avatar, Checkbox, Divider, message, Tag } from "antd";
import { AnimatePresence, motion } from "framer-motion";

import { useDispatch, useSelector } from "react-redux";
import { push } from "connected-react-router";
import JobItem from "../JobItem";
import { setModalState } from "../../../../store/reducers/Modal/actions";
import { FaHeart } from "@react-icons/all-files/fa/FaHeart";
import { JOB_ITEM_VARIANT_SEARCH } from "../JobItem/constants";
import { reportEvent } from "../../../../services/analyticsService";
import { hasCredits } from "../../../../services/billingService";
export default props => {
    const { jobs } = props;
    const { savedJobsObj } = useSelector(({ JobsReducer }) => JobsReducer);
    const { userDetails } = useSelector(({ AuthReducer }) => AuthReducer);
    const [selectedItems, setSelectedItems] = useState([])
    const dispatch = useDispatch()

    const onJobChange = async (jobId, key, val) => {
        if (!hasCredits(userDetails)) {
            reportEvent('upgrade_modal', 'open', { location: 'jobSearchSave' })
            dispatch(setModalState('isUpgradeModalOpen', true))
            return
        }
        let selectedJob
        const updatedJobs = jobs.map(job => {
            if (job._id === jobId) {
                job[key] = val;
                selectedJob = job;
                if (key === 'saved' && !!val) return null;
            }
            return job;
        }).filter(job => !!job)
        props.setJobs(updatedJobs)
        if (key === 'checked' && val === true) {
            setSelectedItems([...selectedItems, selectedJob])
        }
        else if (key === 'checked' && val === false) {
            setSelectedItems([...selectedItems.filter(a => a._id !== jobId)])
        }
        if (key === 'saved' && !!val) {
            reportEvent('search_jobs', 'save_start')
            await postRequest('listing/save', { jobIds: [jobId] })
            const savedJobObj = jobs.filter(job => job._id === jobId)
            message.success(`Woohoo! Job saved successfully 🎯`)
            reportEvent('search_jobs', 'save_success', { jobId: jobId })
            dispatch(refreshStats())
        }
        if (key === 'saved' && !!!val) {
            await postRequest('saved-job/delete', { jobId: jobId })
            dispatch(refreshStats())
        }
    }
    const onSelectAll = (newVal) => {
        const updatedSelection = newVal ? jobs : []
        const selectedJobIds = updatedSelection.map(a => a._id)
        setSelectedItems(updatedSelection);
        const updatedJobs = jobs.map(job => {
            job.checked = selectedJobIds.includes(job._id)

            return job;
        })
        props.setJobs(updatedJobs)
    }
    const onBulkSave = async () => {
        // TODO: Save all the jobs 
        const jobIds = selectedItems.map(a => a._id)
        await postRequest('listing/save', { jobIds })
        // TODO: Navigate to saved jobs
        message.success('Success! All jobs were saved')
        dispatch(refreshStats())
        dispatch(push('/'))

    }
    const onAutoApplyClick = async (job) => {
        props.setJobs(jobs.map(j => {
            if (j._id === job._id) {
                j.loading = true
            }
            return j;
        }))
        dispatch(push('/'))
        const res = await postRequest('saved-job/save-and-apply', { jobIds: [job._id] })
        dispatch(setModalState('isAutoApplyModalOpen', true, { savedJob: res.data.savedJobs[0] }))
        props.setJobs(jobs.map(j => {
            if (j._id === job._id) {
                j.loading = false
            }
            return job;
        }))
    }

    const didSelectAll = selectedItems.length === jobs.length

    return (
        <div className="search-results">
            <div className="indicator">{`${jobs.length} listings`}</div>
            {selectedItems.length ? <div className="checked-items-menu">
                <Checkbox checked disabled />
                <span className="items-count">{selectedItems.length}</span>
                <span className="items-label">{` items`}</span>
                <span className="select-all" onClick={() => onSelectAll(!didSelectAll)}
                >{didSelectAll ? 'Deselect All' : 'Select all'}</span>

                <span className="save-btn" style={{ marginLeft: 15, display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                    onClick={onBulkSave}
                >
                    <FaHeart />
                    Interested

                </span>
            </div> : null}
            <div className="jobs">
                <AnimatePresence>
                    {jobs.map((job) => {
                        return (
                            <motion.div
                                key={job._id}
                                initial={{ opacity: 0, y: 20 }}           // Enter: fade in + slide up
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: -20 }}             // Exit: fade out + move further up
                                transition={{ duration: 0.3 }}
                            >
                                <JobItem key={job._id} job={job} isSaved={savedJobsObj[job._id]} onJobChange={onJobChange}
                                    onAutoApplyClick={onAutoApplyClick} variant={JOB_ITEM_VARIANT_SEARCH}
                                />
                            </motion.div>
                        )
                    })}
                </AnimatePresence>
            </div>
        </div>
    )
}